export default __webpack_public_path__ + "static/media/background_register.5be7a013.jpg";